import { z } from "zod";

// Shared asset view model. The live asset data now comes from ProductCatalog
// (see `@/api/products` + `catalogAssetToAssetMessage`); this schema/type is the
// common shape the Asset Library and TextComposerV2 media picker render against.
//
// NOTE: This is an intentionally permissive schema. The only required fields are the
// ones the UI directly relies on. Uses `.passthrough()` to keep unknown fields so
// the backend can add new ones without breaking validation.
export const assetMessageSchema = z
  .object({
    asset_key: z.string(),
    rj_site_id: z.string(),
    original_filename: z.string(),
    label: z.string(),
    media_type: z.string(),
    // Note: grpc-gateway from connect-api serializes proto int64/uint64 as string in JSON.
    id: z.string().optional(),
    site_id: z.string().nullable().optional(),
    user_id: z.string().nullable().optional(),
    gcs_url: z.string().nullable().optional(),
    cdn_url: z.string().nullable().optional(),
    size_bytes: z.union([z.number(), z.string()]).nullable().optional(),
    checksum_crc32c: z.string().optional(),
    upload_status: z.string().optional(),
    upload_origin: z.string().optional(),
    upload_error: z.string().nullable().optional(),
    uploaded_at: z.string().datetime().nullable().optional(),
    processing_status: z.string().optional(),
    processing_error: z.string().nullable().optional(),
    processed_at: z.string().nullable().optional(),
    create_date: z.string().datetime(),
    modify_date: z.string().datetime(),
    deleted_date: z.string().datetime().nullable().optional(),
  })
  .passthrough();

export type AssetMessage = z.infer<typeof assetMessageSchema>;
